/*
 * The announcement bar ABU publishes centrally, from api.abuniverse.com.
 *
 * The API answers with at most one announcement.
 */
(function () {
  var root = document.querySelector('[data-abu-announcements]');

  if (!root) {
    return;
  }

  var DISMISSED = 'abu_announcement_dismissed';
  var LOCALES = ['en', 'de', 'es', 'fr', 'nl', 'ja'];

  function stored(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function store(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      /* A browser refusing storage reads the bar again next visit. */
    }
  }

  function locale() {
    var asked = (root.dataset.abuLocale || 'en').slice(0, 2).toLowerCase();

    return LOCALES.indexOf(asked) === -1 ? 'en' : asked;
  }

  function endpoint() {
    var base = root.dataset.abuApi || 'https://api.abuniverse.com';

    return (
      base +
      '/announcements?region=' +
      encodeURIComponent(root.dataset.abuRegion || 'eu') +
      '&locale=' +
      encodeURIComponent(locale())
    );
  }

  function arrow() {
    var template = document.querySelector('[data-abu-arrow]');

    return template ? template.content.cloneNode(true) : null;
  }

  function render(announcement) {
    var alignment = root.dataset.abuAlignment || 'center';
    var linked = Boolean(announcement.readMoreUrl);

    var bar = document.createElement('div');
    bar.className =
      'announcement-bar color-' + (root.dataset.abuScheme || 'accent-1') + ' gradient';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', announcement.title);

    var body = document.createElement(linked ? 'a' : 'div');

    if (linked) {
      body.href = announcement.readMoreUrl;
      body.className = 'announcement-bar__link link link--text focus-inset animate-arrow';
    }

    var width = document.createElement('div');
    width.className = 'page-width';

    var message = document.createElement('div');
    message.className = 'announcement-bar__message';

    var title = document.createElement('div');
    title.className = alignment + ' h2 tw-pb-0';
    title.textContent = announcement.title;

    var text = document.createElement('p');
    text.className = alignment + ' h4 tw-mb-0 tw-mt-0';
    text.textContent = announcement.body;

    if (linked) {
      var icon = arrow();

      if (icon) {
        text.appendChild(document.createTextNode(' '));
        text.appendChild(icon);
      }
    }

    message.appendChild(title);
    message.appendChild(text);
    width.appendChild(message);
    body.appendChild(width);

    bar.appendChild(body);

    /* Some announcements have to stay in front of somebody about to order. */
    if (announcement.dismissible !== false) {
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'abu-announcement-bar__close';
      close.setAttribute('aria-label', root.dataset.abuClose || 'Close');
      close.innerHTML = '&times;';
      close.addEventListener('click', function () {
        store(DISMISSED, String(announcement.id));
        root.replaceChildren();
      });

      bar.appendChild(close);
    }

    root.replaceChildren(bar);
  }

  fetch(endpoint(), { headers: { Accept: 'application/json' } })
    .then(function (response) {
      return response.ok ? response.json() : null;
    })
    .then(function (payload) {
      var announcement = payload && payload.data ? payload.data[0] : null;

      if (!announcement) {
        return;
      }

      /*
       * A bar nobody may close ignores what was stored against it, so
       * reopening the same announcement as one that has to stay reaches the
       * readers who closed it before.
       */
      if (announcement.dismissible !== false && String(announcement.id) === stored(DISMISSED)) {
        return;
      }

      render(announcement);
    })
    .catch(function () {
      /* Unreachable, so no bar. */
    });
})();
